// extracted by mini-css-extract-plugin
export default {"typeSelection":"styles_typeSelection__8yvI3","toggleSelected":"styles_toggleSelected__KwEnA"};